import { TypographyStyles } from '@/styles'
import { Text, Image, Button } from '@/ui'
import { useNavigate } from 'react-router-dom'

export const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col gap-4 items-center justify-center mt-12 text-center w-full">
      <Image
        src="https://heard-images.s3.amazonaws.com/assets/two_chairs.svg"
        className="mx-auto"
        width={400}
        alt="not-found"
      />
      <Text variant={TypographyStyles.H1}>Page Not Found</Text>
      <Text variant={TypographyStyles.H3} className="mt-4">
        Please return to the previous page.
      </Text>
      <Button onClick={() => navigate(-1)}>Go Back</Button>
    </div>
  )
}
